var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeMove = function SvgHomeMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M5.854 24.253A2.5 2.5 0 0 0 5 26.134V47.5A2.5 2.5 0 0 0 7.5 50h10a2.5 2.5 0 0 0 2.5-2.5v-10a2.5 2.5 0 0 1 2.5-2.5h5a2.5 2.5 0 0 1 2.5 2.5v10a2.5 2.5 0 0 0 2.5 2.5h10a2.5 2.5 0 0 0 2.5-2.5V26.135a2.5 2.5 0 0 0-.854-1.882l-17.5-15.312a2.5 2.5 0 0 0-3.292 0M3.75 5 20 21.25M3.75 5v7.5m0-7.5h7.5M20 21.25V15m0 6.25h-7.5"
  })));
};
export default SvgHomeMove;